export default {
  allMsg: 'Tutti i messaggi',
  systemMsg: 'Messaggi di sistema',
  personMsg: 'Messaggi manuali',
  unread: 'Non letto',
  seeDetail: 'Vedi dettagli',
  read: 'Letto',
  replyNow: 'Rispondi ora',
  message: 'Messaggio',
  operateSuccess: 'Operazione riuscita',
  holder: {
    searchHolder: 'N. pacco/N. ordine/N. articolo',
  },
  addAcBuy: 'Unisciti ad AcBuy Discord e vinci 2000 ¥ in CASH!',
  flatActivity: '🎄 Offerte Imperdibili di Natale',
  joinNow1: 'Acquista Ora',
  tips1: '🎁 Sconti Fino all’80 %',
  tips2: '🎅 Promozioni Natalizie a Tempo Limitato!',
}
